import type { NavigationGuardReturn, RouteLocationNormalized } from 'vue-router';

import { useAuthStore } from '@/entities/auth';

/**
 * Платформенные маршруты доступны только владельцу платформы.
 */
export const superuserGuard = (to: RouteLocationNormalized): NavigationGuardReturn => {
  if (to.meta.superuser !== true) {
    return true;
  }

  const authStore = useAuthStore();

  if (!authStore.user?.is_super_user) {
    return { name: 'auth.platform-access-denied' };
  }

  return true;
};
